import { render, staticRenderFns } from "./JoinBanner.vue?vue&type=template&id=30a5a950&scoped=true&"
import script from "./JoinBanner.vue?vue&type=script&lang=js&"
export * from "./JoinBanner.vue?vue&type=script&lang=js&"
import style0 from "styles/views/join/joinbanner.css?vue&type=style&index=0&id=30a5a950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a5a950",
  null
  
)

export default component.exports